import type { CSSProperties } from "react";
import { IconBell, IconPlus, IconSearch } from "../common/Icons";
import { PINK, VARIANT, type VariantId } from "../../lib/tokens";
import { usePublicAuth } from "../../hooks/usePublicAuth";

export function TopBar({
  variant,
  loggedIn,
}: {
  variant: VariantId;
  loggedIn: boolean;
}) {
  const { signIn } = usePublicAuth();
  const v = VARIANT[variant];
  const isDark = variant === "immersive";

  const bg = isDark ? "rgba(10,10,10,0.9)" : "rgba(255,255,255,0.9)";

  const iconBtn: CSSProperties = {
    position: "relative",
    width: 38,
    height: 38,
    borderRadius: "50%",
    border: "none",
    background: "transparent",
    color: v.muted,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 40,
        background: bg,
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderBottom: `1px solid ${v.border}`,
        padding: "14px 32px",
        display: "flex",
        alignItems: "center",
        gap: 16,
      }}
    >
      <div style={{ flex: 1, maxWidth: 560, position: "relative" }}>
        <div
          style={{
            position: "absolute",
            left: 14,
            top: "50%",
            transform: "translateY(-50%)",
            color: v.muted,
            pointerEvents: "none",
          }}
        >
          <IconSearch size={16} />
        </div>
        <input
          placeholder="Scrollys, Creator, Themen suchen…"
          style={{
            width: "100%",
            background: v.searchBg,
            border: "1px solid transparent",
            borderRadius: 999,
            padding: "10px 16px 10px 40px",
            fontSize: 14,
            color: v.text,
            outline: "none",
            fontFamily: "inherit",
            boxSizing: "border-box",
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = PINK;
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = "transparent";
          }}
        />
      </div>

      <div style={{ flex: 1 }} />

      {loggedIn ? (
        <>
          <button
            onClick={() => {
              window.location.href = import.meta.env.VITE_EDITOR_BASE_URL ?? "https://editor.scrolly.com";
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              border: "none",
              background: PINK,
              color: "#fff",
              fontWeight: 600,
              padding: "9px 16px 9px 12px",
              borderRadius: 999,
              fontSize: 13.5,
              cursor: "pointer",
              fontFamily: "inherit",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <IconPlus size={16} /> Erstellen
          </button>
          <button style={iconBtn} title="Benachrichtigungen">
            <IconBell size={18} />
            <span
              style={{
                position: "absolute",
                top: 6,
                right: 6,
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: PINK,
                border: `2px solid ${isDark ? "#0a0a0a" : "#fff"}`,
              }}
            />
          </button>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              background: "#111",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            BH
          </div>
        </>
      ) : (
        <>
          <button
            onClick={() => signIn(window.location.href)}
            style={{
              border: "none",
              background: "transparent",
              color: v.text,
              fontSize: 14,
              fontWeight: 500,
              padding: "8px 14px",
              borderRadius: 999,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Anmelden
          </button>
          <button
            onClick={() => signIn(import.meta.env.VITE_EDITOR_BASE_URL ?? "https://editor.scrolly.com")}
            style={{
              border: "none",
              background: PINK,
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              padding: "9px 18px",
              borderRadius: 999,
              cursor: "pointer",
              fontFamily: "inherit",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            Scrolly starten
          </button>
        </>
      )}
    </header>
  );
}
